
import { AppService } from "app/services/app.service";
import { AppFilter } from "app/models/app-filter.model";
import { Observable } from "rxjs";

export abstract class AbLogNotificacao extends AppService {
  abstract getAllLogs(filter: AppFilter): Observable<any>;
  abstract getNotificacao(id: number, tipo: string): Observable<any>;
  abstract getAllLogsDispositivo(filter: AppFilter): Observable<any>;
}